"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Transition = _interopRequireDefault(require("react-transition-group/Transition"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var duration = 300;
var defaultStyle = {
  transition: "opacity ".concat(duration, "ms ease-in-out"),
  opacity: 1
};
var transitionStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  }
};
var JazzyButton = function JazzyButton(_ref) {
  var text = _ref.text,
    loading = _ref.loading,
    buttonColor = _ref.buttonColor,
    onClick = _ref.onClick,
    error = _ref.error,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_Transition["default"], {
    "in": visible,
    timeout: duration
  }, function (state) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-".concat(buttonColor || 'secondary', " ").concat(className),
      disabled: loading || error,
      onClick: onClick,
      style: _objectSpread(_objectSpread({}, defaultStyle), transitionStyles[state])
    }, /*#__PURE__*/_react["default"].createElement("span", null, loading ? /*#__PURE__*/_react["default"].createElement("i", {
      className: "fa fa-circle-o-notch fa-spin fa-fw"
    }) : text));
  });
};
JazzyButton.propTypes = {
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  loading: _propTypes["default"].bool,
  buttonColor: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  error: _propTypes["default"].bool,
  visible: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var _default = exports["default"] = JazzyButton;